import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getTranslation } from 'common/react/utils/translations';
import { SvgIcon } from 'common/react/components/SvgIcon';
import { ManageStatsModal } from '../modal/ManageStatsModal';
import {
    playerStatsCustomFieldsSelector,
    playerStatsModalSelector
} from 'store/modules/mc-player-stats/selectors';
import { playerStatsTemporaryFieldsSelector } from 'store/modules/mc-player-stats/selectors/temporary-fields-selector';
import {
    setCustomFields,
    setModal,
    setTemporaryFields
} from 'common/store/modules/mc-player-stats/init';

export const ManageStatsButton = () => {
    const dispatch = useDispatch();
    const isModalOpen = useSelector(playerStatsModalSelector)?.isOpen;
    const ref = useRef();
    const TABLE_NAME = 'mcPlayerStats';
    const initialFields = useSelector(playerStatsTemporaryFieldsSelector);
    const customFields = useSelector(playerStatsCustomFieldsSelector);

    const toggleModal = ({ confirm = false } = {}) => {
        if (isModalOpen) {
            if (confirm) {
                // Update initial fields
                dispatch(
                    setTemporaryFields({
                        data: [...customFields]
                    })
                );
            } else {
                // Reset the table to the initial fields when the user closes the modal instead of confirming
                localStorage.setItem(TABLE_NAME, JSON.stringify(initialFields));
                dispatch(
                    setCustomFields({
                        data: [...initialFields]
                    })
                );
            }
        }
        dispatch(
            setModal({
                isOpen: !isModalOpen
            })
        );
    };

    useEffect(() => {
        // Set the z-index of the player stats tab
        // which avoids the modal appearing below other elements on the page
        const tab = ref.current?.closest('.js-mc-tab');

        if (tab) {
            if (isModalOpen && !tab.classList.contains('is-modal-open')) {
                tab.classList.add('is-modal-open');
            } else if (
                !isModalOpen &&
                tab.classList.contains('is-modal-open')
            ) {
                tab.classList.remove('is-modal-open');
            }
        }
    }, [isModalOpen]);

    return (
        <>
            <button
                ref={ref}
                className="filter-button"
                onClick={() => toggleModal()}
            >
                <SvgIcon icon="edit" className="icon manage-stats-icon" />
                {getTranslation('label.customTable.manageStatsButton')}
            </button>

            <ManageStatsModal
                isModalOpen={isModalOpen}
                toggleModal={toggleModal}
            />
        </>
    );
};
